document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.getElementById('nd-mobile-menu-new');
  const toggle = document.querySelector('.nd-mobile-new-toggle');
  const closeBtn = document.querySelector('.nd-mobile-new-overlay__close');
  const searchInput = overlay ? overlay.querySelector('[data-predictive-search-input]') : null;
  const predictiveSearch = overlay ? overlay.querySelector('predictive-search') : null;
  const searchButton = overlay ? overlay.querySelector('.search__predictive__button') : null;
  const accordionAnimationDuration = 240;
  const menuScrollDuration = 260;
  const menuScrollOffset = 28;
  let activeScrollFrame = null;

  if (!overlay || !toggle) return;

  const focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]';

  if (overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);
  }

  function setOverlayFocusableState(shouldOpen) {
    overlay.querySelectorAll(focusableSelector).forEach((element) => {
      if (shouldOpen) {
        if (element.hasAttribute('data-mobile-new-tabindex')) {
          const previousTabindex = element.getAttribute('data-mobile-new-tabindex');
          if (previousTabindex === 'none') {
            element.removeAttribute('tabindex');
          } else {
            element.setAttribute('tabindex', previousTabindex);
          }
          element.removeAttribute('data-mobile-new-tabindex');
        }
        return;
      }

      if (!element.hasAttribute('data-mobile-new-tabindex')) {
        if (element.hasAttribute('tabindex')) {
          element.setAttribute('data-mobile-new-tabindex', element.getAttribute('tabindex'));
        } else {
          element.setAttribute('data-mobile-new-tabindex', 'none');
        }
      }
      element.setAttribute('tabindex', '-1');
    });
  }

  function setOverlayState(shouldOpen) {
    const shouldRestoreFocus = !shouldOpen && overlay.contains(document.activeElement);

    if (!shouldOpen) {
      predictiveSearch?.reset();
      searchInput?.blur();
    }

    overlay.classList.toggle('is-open', shouldOpen);
    overlay.setAttribute('aria-hidden', String(!shouldOpen));
    toggle.setAttribute('aria-expanded', String(shouldOpen));
    toggle.classList.toggle('mobile_menu_active', shouldOpen);

    if (shouldOpen) {
      overlay.removeAttribute('inert');
    } else {
      overlay.setAttribute('inert', '');
    }

    setOverlayFocusableState(shouldOpen);
    document.body.classList.toggle('overflow-hidden', shouldOpen);
    document.documentElement.classList.toggle('overflow-hidden', shouldOpen);

    if (shouldRestoreFocus) {
      window.requestAnimationFrame(function () {
        toggle.focus();
      });
    }
  }

  function focusOverlaySearch() {
    if (!searchInput) return;

    window.requestAnimationFrame(function () {
      searchInput.focus();
      if (typeof searchInput.select === 'function') {
        searchInput.select();
      }
    });
  }

  function openOverlay(options) {
    const shouldFocusSearch = options && options.focusSearch;

    document.dispatchEvent(new CustomEvent('nd:search-popdown:close'));

    if (!overlay.classList.contains('is-open')) {
      setOverlayState(true);
    }

    const scrollContainer = overlay.querySelector('.nd-mobile-new-overlay__scroll');
    if (scrollContainer) {
      cancelMenuScroll();
      scrollContainer.scrollTop = 0;
    }

    if (shouldFocusSearch) {
      focusOverlaySearch();
    }
  }

  function cancelMenuScroll() {
    if (activeScrollFrame) {
      window.cancelAnimationFrame(activeScrollFrame);
      activeScrollFrame = null;
    }
  }

  function easeInOutCubic(progress) {
    if (progress < 0.5) {
      return 4 * progress * progress * progress;
    }

    return 1 - Math.pow(-2 * progress + 2, 3) / 2;
  }

  function animateMenuScroll(scrollContainer, targetScrollTop) {
    if (!scrollContainer) return Promise.resolve();

    cancelMenuScroll();

    const startScrollTop = scrollContainer.scrollTop;
    const boundedTarget = Math.max(targetScrollTop, 0);

    if (Math.abs(boundedTarget - startScrollTop) < 2) {
      scrollContainer.scrollTop = boundedTarget;
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      const startTime = window.performance.now();

      function step(now) {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / menuScrollDuration, 1);
        const easedProgress = easeInOutCubic(progress);

        scrollContainer.scrollTop = startScrollTop + (boundedTarget - startScrollTop) * easedProgress;

        if (progress < 1) {
          activeScrollFrame = window.requestAnimationFrame(step);
          return;
        }

        activeScrollFrame = null;
        resolve();
      }

      activeScrollFrame = window.requestAnimationFrame(step);
    });
  }

  function animateSubmenu(submenu, shouldOpen) {
    if (!submenu) return;

    const duration = accordionAnimationDuration;
    if (typeof submenu.getAnimations === 'function') {
      submenu.getAnimations().forEach((animation) => animation.cancel());
    }

    const supportsElementAnimation = typeof submenu.animate === 'function';

    if (!supportsElementAnimation) {
      submenu.hidden = !shouldOpen;
      submenu.style.height = '';
      submenu.style.overflow = '';
      submenu.style.opacity = '';
      return null;
    }

    if (shouldOpen) {
      submenu.hidden = false;
      const endHeight = submenu.scrollHeight;
      submenu.style.height = '0px';
      submenu.style.overflow = 'hidden';
      submenu.style.willChange = 'height, opacity, transform';

      const animation = submenu.animate(
        [
          { height: '0px', opacity: 0, transform: 'translate3d(0, -8px, 0)' },
          { height: `${endHeight}px`, opacity: 1, transform: 'translate3d(0, 0, 0)' },
        ],
        { duration, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
      );

      animation.addEventListener('finish', function () {
        submenu.style.height = '';
        submenu.style.overflow = '';
        submenu.style.opacity = '';
        submenu.style.transform = '';
        submenu.style.willChange = '';
      });
      return animation;
    }

    const activeElement = document.activeElement;
    if (activeElement && submenu.contains(activeElement) && typeof activeElement.blur === 'function') {
      activeElement.blur();
    }

    const startHeight = submenu.scrollHeight;
    submenu.style.height = `${startHeight}px`;
    submenu.style.overflow = 'hidden';
    submenu.style.willChange = 'height, opacity, transform';
    const animation = submenu.animate(
      [
        { height: `${startHeight}px`, opacity: 1, transform: 'translate3d(0, 0, 0)' },
        { height: '0px', opacity: 0, transform: 'translate3d(0, -8px, 0)' },
      ],
      { duration, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
    );

    animation.addEventListener('finish', function () {
      submenu.hidden = true;
      submenu.style.height = '';
      submenu.style.overflow = '';
      submenu.style.opacity = '';
      submenu.style.transform = '';
      submenu.style.willChange = '';
    });

    return animation;
  }

  function scrollMenuItemToTop(listItem) {
    const scrollContainer = overlay.querySelector('.nd-mobile-new-overlay__scroll');
    if (!scrollContainer || !listItem) return;

    const containerTop = scrollContainer.getBoundingClientRect().top;
    const itemTop = listItem.getBoundingClientRect().top;
    const nextScrollTop = scrollContainer.scrollTop + itemTop - containerTop - menuScrollOffset;

    return animateMenuScroll(scrollContainer, nextScrollTop);
  }

  function animateProjectedMenuItemScroll(listItem, closingItem) {
    const scrollContainer = overlay.querySelector('.nd-mobile-new-overlay__scroll');
    if (!scrollContainer || !listItem || !closingItem) {
      return Promise.resolve();
    }

    const closingSubmenu = closingItem.querySelector(':scope > .nd-mobile-new-submenu');
    const closingIsAbove = Boolean(closingItem.compareDocumentPosition(listItem) & Node.DOCUMENT_POSITION_FOLLOWING);
    const closingHeightAdjustment = closingIsAbove && closingSubmenu ? closingSubmenu.scrollHeight : 0;
    const containerTop = scrollContainer.getBoundingClientRect().top;
    const itemTop = listItem.getBoundingClientRect().top;
    const projectedScrollTop = scrollContainer.scrollTop + itemTop - containerTop - closingHeightAdjustment - menuScrollOffset;

    return animateMenuScroll(scrollContainer, projectedScrollTop);
  }

  function waitForAnimation(animation) {
    if (!animation || !animation.finished) {
      return Promise.resolve();
    }

    return animation.finished.catch(function () {
      return null;
    });
  }

  if (searchButton && searchInput) {
    searchButton.addEventListener('pointerdown', function (event) {
      if (document.activeElement !== searchInput) {
        event.preventDefault();
      }
    });

    searchButton.addEventListener('click', function (event) {
      if (document.activeElement !== searchInput) {
        event.preventDefault();
        searchInput.focus();
      }
    });
  }

  toggle.addEventListener('click', function () {
    const isOpen = overlay.classList.contains('is-open');
    if (isOpen) {
      setOverlayState(false);
      return;
    }

    openOverlay({ focusSearch: false });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      setOverlayState(false);
    });
  }

  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) {
      setOverlayState(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
      setOverlayState(false);
    }
  });

  document.addEventListener('nd:mobile-menu:close', function () {
    if (overlay.classList.contains('is-open')) {
      setOverlayState(false);
    }
  });

  document.querySelectorAll('.nd-mobile-new-menu__trigger').forEach((button) => {
    button.addEventListener('click', function () {
      const listItem = button.closest('.nd-mobile-new-menu__item');
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      const openItem = document.querySelector('.nd-mobile-new-menu__item.is-open');
      let closeAnimation = null;

      if (openItem && openItem !== listItem) {
        openItem.classList.remove('is-open');
        const openItemButton = openItem.querySelector('.nd-mobile-new-menu__trigger');
        if (openItemButton) openItemButton.setAttribute('aria-expanded', 'false');
        const openSubmenu = openItem.querySelector(':scope > .nd-mobile-new-submenu');
        closeAnimation = animateSubmenu(openSubmenu, false);
      }

      if (isOpen && listItem) {
        listItem.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        const submenu = listItem.querySelector(':scope > .nd-mobile-new-submenu');
        cancelMenuScroll();
        animateSubmenu(submenu, false);
        return;
      }

      if (listItem) {
        listItem.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        const submenu = listItem.querySelector(':scope > .nd-mobile-new-submenu');
        const openAnimation = animateSubmenu(submenu, true);
        const animationSettle = Promise.allSettled([waitForAnimation(closeAnimation), waitForAnimation(openAnimation)]);
        const projectedScroll = openItem && openItem !== listItem ? animateProjectedMenuItemScroll(listItem, openItem) : null;

        const alignOpenedItem = function () {
          window.requestAnimationFrame(function () {
            scrollMenuItemToTop(listItem);
          });
        };

        Promise.allSettled([animationSettle, projectedScroll]).then(alignOpenedItem);

        // Auto-open all second-level groups when first-level is opened.
        listItem.querySelectorAll('.nd-mobile-new-submenu__group').forEach((group) => {
          group.classList.add('is-open');
        });
      }
    });
  });

  // Prevent collapsed items from reserving visual space.
  document.querySelectorAll('.nd-mobile-new-menu__item').forEach((item) => {
    const submenu = item.querySelector(':scope > .nd-mobile-new-submenu');
    if (!submenu) return;
    submenu.hidden = !item.classList.contains('is-open');
  });

  setOverlayState(false);
});
